import styled from 'styled-components'
import { omniaTheme } from '../../theme/omniaTheme'

// ============================================================
// Page-level wrapper
// ============================================================

export const HighlightsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 14mm 14mm 14mm 14mm;
  box-sizing: border-box;

  @media print {
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 14mm 14mm 14mm 14mm !important;
  }
`

// ============================================================
// Metric cards: 2 rows × 3 columns
// ============================================================

export const MetricCardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr !important;
    gap: 12px !important;
  }
`

export const MetricCard = styled.div`
  background: ${omniaTheme.colors.cardBg};
  padding: 20px;
  border: 0;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 120px;
  box-sizing: border-box;
  gap: 8px;

  @media print {
    background: ${omniaTheme.colors.cardBg} !important;
    padding: 20px !important;
    border: 0 !important;
    border-radius: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    height: 120px !important;
    box-sizing: border-box !important;
    gap: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: ${omniaTheme.colors.primary};

  svg {
    display: block;
    width: 24px;
    height: 24px;
  }

  @media print {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 28px !important;
    height: 28px !important;
    color: ${omniaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricValue = styled.div`
  font-family: ${omniaTheme.fonts.heading};
  font-size: 22px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.black};
  letter-spacing: ${omniaTheme.letterSpacing.tight};
  line-height: 1;

  @media print {
    font-family: ${omniaTheme.fonts.heading} !important;
    font-size: 22px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.black} !important;
    letter-spacing: ${omniaTheme.letterSpacing.tight} !important;
    line-height: 1 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricLabel = styled.div`
  font-family: ${omniaTheme.fonts.label};
  font-size: 9px;
  font-weight: ${omniaTheme.fontWeights.light};
  color: ${omniaTheme.colors.textLabel};
  letter-spacing: ${omniaTheme.letterSpacing.wide};
  text-transform: uppercase;
  line-height: 1.2;

  @media print {
    font-family: ${omniaTheme.fonts.label} !important;
    font-size: 9px !important;
    font-weight: ${omniaTheme.fontWeights.light} !important;
    color: ${omniaTheme.colors.textLabel} !important;
    letter-spacing: ${omniaTheme.letterSpacing.wide} !important;
    text-transform: uppercase !important;
    line-height: 1.2 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

// ============================================================
// "Caractéristiques clés" subhead
// ============================================================

export const FeaturesSubhead = styled.h3`
  font-family: ${omniaTheme.fonts.heading};
  font-size: 14px;
  font-weight: ${omniaTheme.fontWeights.medium};
  color: ${omniaTheme.colors.black};
  letter-spacing: ${omniaTheme.letterSpacing.tight};
  margin: 32px 0 16px 0;

  @media print {
    font-family: ${omniaTheme.fonts.heading} !important;
    font-size: 14px !important;
    font-weight: ${omniaTheme.fontWeights.medium} !important;
    color: ${omniaTheme.colors.black} !important;
    margin: 32px 0 16px 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

// ============================================================
// Attribute chips: 2 rows × 4 columns
// ============================================================

export const AttributeChipsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 8px;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr 1fr !important;
    gap: 8px !important;
  }
`

export const AttributeChip = styled.div`
  background: ${omniaTheme.colors.cardBg};
  border: 0.5px solid ${omniaTheme.colors.border};
  border-radius: 0;
  padding: 12px 16px;
  height: 44px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 12px;

  @media print {
    background: ${omniaTheme.colors.cardBg} !important;
    border: 0.5px solid ${omniaTheme.colors.border} !important;
    border-radius: 0 !important;
    padding: 12px 16px !important;
    height: 44px !important;
    box-sizing: border-box !important;
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AttributeIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: ${omniaTheme.colors.primary};

  svg {
    display: block;
    width: 16px;
    height: 16px;
  }

  @media print {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 16px !important;
    height: 16px !important;
    color: ${omniaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AttributeLabel = styled.span`
  font-family: ${omniaTheme.fonts.body};
  font-size: 11px;
  font-weight: ${omniaTheme.fontWeights.normal};
  color: ${omniaTheme.colors.text};
  line-height: 1.2;

  @media print {
    font-family: ${omniaTheme.fonts.body} !important;
    font-size: 11px !important;
    font-weight: ${omniaTheme.fontWeights.normal} !important;
    color: ${omniaTheme.colors.text} !important;
    line-height: 1.2 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
